import { cloneDeep } from 'lodash';
import { ISize, IWeight } from '../../types/Endpoints/goods/ProductContracts';
import { IModifyDataForForm } from '../../pages/Goods/EditGood/PriceOffers/interface';

/** 0 в форме цен считаем пустым значением (невалидный 0 не показываем как заполненное поле) */
const normalizePriceForForm = (price: number): number => (
    price === 0 ? '' as unknown as number : price
);

const normalizeWeightPrices = (weight: IWeight): IWeight => {
    const cloned = cloneDeep(weight);

    if (cloned.insert?.[0]) {
        cloned.insert[0].price = normalizePriceForForm(cloned.insert[0].price);
        cloned.insert[0].discountPrice = normalizePriceForForm(cloned.insert[0].discountPrice);
        cloned.insert[0].discountPriceDC = normalizePriceForForm(cloned.insert[0].discountPriceDC);
    }

    return cloned;
};

export const modifyDataForFormPriceOffers = (sizes: ISize[] | undefined): IModifyDataForForm[] => {
    const result: IModifyDataForForm[] = [];

    sizes?.forEach(size => {
        if (size.weight.length > 1) {
            size.weight.forEach(weight => {
                result.push({
                    id: size.id,
                    size: size.size,
                    weight: normalizeWeightPrices(weight),
                });
            });
        } else if (size.weight.length) {
            result.push({
                id: size.id,
                size: size.size,
                weight: normalizeWeightPrices(size.weight[0]),
            });
        }
    });

    return result;
};
